import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";

export default function VerifyEmail() {
  const { verifyEmail, logout } = useApp();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    logout();
  verifyEmail(token)
  .then((r) => {
    console.log("VERIFY OK:", r);
    setStatus("success");
  })
  .catch((e) => {
    console.error("VERIFY ERROR:", e);
    setStatus("error");
  });
  }, [token]);

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {status === "loading" && (
          <>
            <div style={{fontSize:48,textAlign:"center"}}>⏳</div>
            <p style={s.title}>Verificando tu email...</p>
          </>
        )}
        {status === "success" && (
          <>
            <div style={{fontSize:48,textAlign:"center"}}>✅</div>
            <p style={s.title}>Email verificado!</p>
            <p style={s.text}>Tu email fue verificado correctamente. Los administradores van a revisar tu solicitud y te avisaran cuando este aprobada.</p>
            <Link to="/login" style={s.btn}>Ir al inicio</Link>
          </>
        )}
        {status === "error" && (
          <>
            <div style={{fontSize:48,textAlign:"center"}}>❌</div>
            <p style={s.title}>Link invalido</p>
            <p style={s.text}>El link de verificacion es invalido o ya fue usado.</p>
            <Link to="/register" style={s.btn}>Volver al registro</Link>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  wrap:{minHeight:"calc(100vh - 68px)",background:"#f5f5f5",display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  card:{background:"#fff",borderRadius:16,padding:"36px 32px",width:"100%",maxWidth:400,boxShadow:"0 2px 16px rgba(0,0,0,0.06)",textAlign:"center",display:"flex",flexDirection:"column",gap:16},
  title:{fontSize:22,fontWeight:600,color:"#111"},
  text:{fontSize:14,color:"#666",lineHeight:1.6},
  btn:{display:"block",background:"#1D9E75",color:"#fff",borderRadius:10,padding:"13px",fontSize:15,fontWeight:500,textDecoration:"none",marginTop:8},
};
